import React, { ReactElement } from 'react';
import ContentLoader from 'react-content-loader';

type Props = {
  sportType: string;
};

const Loader = ({ sportType }: Props): ReactElement => {
  const backgroundColor = sportType === 'icehockey' ? '#1c5e98' : '#356d48';
  const foregroundColor = sportType === 'icehockey' ? '#00abff' : '#6eb185';
  return (
    <ContentLoader
      speed={1}
      width="100%"
      height="350px"
      viewBox="0 0 500 340"
      backgroundColor={backgroundColor}
      foregroundColor={foregroundColor}>
      <circle cx="300" cy="173" r="54" />
      <rect x="66" y="15" rx="5" ry="5" width="375" height="15" />
      <rect x="85" y="75" rx="5" ry="5" width="70" height="70" />
      <rect x="70" y="15" rx="5" ry="5" width="300" height="15" />
      <rect x="330" y="83" rx="0" ry="0" width="29" height="0" />
      <rect x="345" y="75" rx="5" ry="5" width="70" height="70" />
      <rect x="77" y="165" rx="5" ry="5" width="87" height="13" />
      <rect x="365" y="176" rx="0" ry="0" width="3" height="2" />
      <rect x="337" y="165" rx="5" ry="5" width="87" height="13" />
      <rect x="66" y="210" rx="5" ry="5" width="145" height="14" />
      <rect x="66" y="245" rx="5" ry="5" width="145" height="14" />
      <rect x="66" y="280" rx="5" ry="5" width="145" height="14" />
      <rect x="242" y="210" rx="0" ry="0" width="20" height="14" />
      <rect x="242" y="245" rx="0" ry="0" width="20" height="14" />
      <rect x="242" y="280" rx="0" ry="0" width="20" height="14" />
      <rect x="290" y="210" rx="5" ry="5" width="145" height="14" />
      <rect x="290" y="245" rx="5" ry="5" width="145" height="14" />
      <rect x="290" y="280" rx="5" ry="5" width="145" height="14" />
    </ContentLoader>
  );
};
export default Loader;
